(function () {
  'use strict';

  var bookingButtonSelector = '#apntly-book-button';
  var bookingFrameSelector = '#apntly-booking-iframe';
  var expectedAppointments = 1;
  var hookTimer = null;
  var hookedClients = new WeakSet();

  function getQuantityInput(button) {
    var form = button && button.closest('form');

    if (form && form.elements && form.elements.namedItem('quantity')) {
      return form.elements.namedItem('quantity');
    }

    return document.querySelector('.product__quantity input[name="quantity"]');
  }

  function readExpectedAppointments(button) {
    var input = getQuantityInput(button);
    var quantity = input ? parseInt(input.value, 10) : 1;

    return Number.isFinite(quantity) && quantity > 0 ? quantity : 1;
  }

  function appointmentStatusText(selected) {
    var remaining = Math.max(expectedAppointments - selected, 0);

    if (remaining === 0) {
      return selected + ' von ' + expectedAppointments +
        ' Terminen ausgewählt. Sie können jetzt fortfahren.';
    }

    return selected + ' von ' + expectedAppointments +
      ' Terminen ausgewählt. Bitte wählen Sie noch ' + remaining +
      (remaining === 1 ? ' separaten Termin.' : ' separate Termine.');
  }

  function renderAppointmentStatus(client) {
    var frame = document.querySelector(bookingFrameSelector);
    var frameDocument;

    try {
      frameDocument = frame && frame.contentDocument;
    } catch (error) {
      return;
    }

    if (!frameDocument || !frameDocument.body) return;

    var data = client && client.apntlyBookingModalData;
    var selected = data && Array.isArray(data.cartItems) ? data.cartItems.length : 0;
    var status = frameDocument.getElementById('pdb-appointly-quantity-status');

    if (!status) {
      status = frameDocument.createElement('div');
      status.id = 'pdb-appointly-quantity-status';
      status.setAttribute('role', 'status');
      status.style.cssText = [
        'margin:0 0 16px',
        'padding:12px 14px',
        'border:1px solid #d8bca6',
        'border-radius:8px',
        'background:#fff8f2',
        'color:#241f1b',
        'font-size:14px',
        'font-weight:600',
        'line-height:1.4'
      ].join(';');

      var target = frameDocument.querySelector('.select-time-slot') ||
        frameDocument.querySelector('.side-menu') || frameDocument.body.firstChild;

      if (target && target.parentNode) {
        target.parentNode.insertBefore(status, target);
      } else {
        frameDocument.body.insertBefore(status, frameDocument.body.firstChild);
      }
    }

    status.textContent = appointmentStatusText(selected);
    status.style.borderColor = selected === expectedAppointments ? '#8baa82' : '#d8bca6';
    status.style.background = selected === expectedAppointments ? '#f2f8f0' : '#fff8f2';
  }

  function enforceExpectedAppointments(client) {
    var data = client && client.apntlyBookingModalData;

    if (!data || !Array.isArray(data.cartItems)) return;

    if (data.cartItems.length > expectedAppointments) {
      data.cartItems.splice(expectedAppointments);
    }

    if (data.cartItems.length !== expectedAppointments &&
        typeof client.setBookNowButtonState === 'function' &&
        data.bookNowDisabled !== true) {
      client.setBookNowButtonState(true);
    }

    renderAppointmentStatus(client);
  }

  function hookAppointlyClient() {
    var client = window.appointlyClient;

    if (!client) return false;
    if (hookedClients.has(client)) {
      enforceExpectedAppointments(client);
      return true;
    }

    hookedClients.add(client);

    if (typeof client.isBookNowButtonDisabled === 'function') {
      var originalButtonState = client.isBookNowButtonDisabled;

      client.isBookNowButtonDisabled = function () {
        var result = originalButtonState.apply(this, arguments);
        enforceExpectedAppointments(this);
        return result;
      };
    }

    if (typeof client.onSelectionChange === 'function') {
      var originalSelectionChange = client.onSelectionChange;

      client.onSelectionChange = function () {
        enforceExpectedAppointments(this);
        var result = originalSelectionChange.apply(this, arguments);

        Promise.resolve(result).finally(function () {
          if (typeof client.isBookNowButtonDisabled === 'function') {
            client.isBookNowButtonDisabled();
          }
          enforceExpectedAppointments(client);
        });

        return result;
      };
    }

    if (typeof client.onBookNowClicked === 'function') {
      var originalBookNow = client.onBookNowClicked;

      client.onBookNowClicked = function () {
        var data = this.apntlyBookingModalData;
        var selected = data && Array.isArray(data.cartItems) ? data.cartItems.length : 0;

        if (selected !== expectedAppointments) {
          enforceExpectedAppointments(this);
          window.alert(appointmentStatusText(selected));
          return Promise.resolve();
        }

        return originalBookNow.apply(this, arguments);
      };
    }

    enforceExpectedAppointments(client);
    return true;
  }

  function startHooking() {
    window.clearInterval(hookTimer);

    var attempts = 0;
    hookTimer = window.setInterval(function () {
      attempts += 1;
      hookAppointlyClient();

      if (window.appointlyClient) {
        renderAppointmentStatus(window.appointlyClient);
      }

      if (attempts >= 80) {
        window.clearInterval(hookTimer);
      }
    }, 250);
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest(bookingButtonSelector);

    if (!button) return;

    expectedAppointments = readExpectedAppointments(button);
    window.pdbAppointlyExpectedAppointments = expectedAppointments;
    startHooking();
  }, true);

  document.addEventListener('DOMContentLoaded', function () {
    var button = document.querySelector(bookingButtonSelector);

    if (!button) return;

    expectedAppointments = readExpectedAppointments(button);
    window.pdbAppointlyExpectedAppointments = expectedAppointments;
    startHooking();
  });
})();
